<template>
  <div>
    <SideMenu v-if="this.showMenu()" :rotas="this.getRoutes()" txtcolor="#fff" bgcolor="#2f96f3"></SideMenu>
    <div class="container-fluid">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import { routes } from "./routes";
import SideMenu from "./components/shared/side-menu/SideMenu";

export default {
  components: {
    SideMenu
  },

  data() {
    return {};
  },

  methods: {
    showMenu() {
      let url_recovery = window.location.pathname.split("/");
      url_recovery = url_recovery[1] + "/" + url_recovery[2];

      if (this.$route.path == "/" || url_recovery == "usuarios/senha" || url_recovery == "usuarios/recuperar") {
        return false;
      } else {
        return true;
      }
    },

    getRoutes() {
      var arr = routes.filter(route => route.menu);

      for (var i = 0; i < arr.length; i++) {
        if (arr[i].name == "logout" && !localStorage.getItem("access_token")) {
          arr.splice(i, 1);
        }
      }
      return arr;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue